import React, { useEffect } from 'react';
import DocumentationSidebar from '../component/DocumentationSidebar';
import Searchbar from '../component/SearchBar';
import image001 from '../assetes/images/survey/action-in-calculator-list/image001.png';
import image002 from '../assetes/images/survey/action-in-calculator-list/image002.png';
import image003 from '../assetes/images/survey/action-in-calculator-list/image003.png';
import image004 from '../assetes/images/survey/action-in-calculator-list/image004.png';
import image005 from '../assetes/images/survey/action-in-calculator-list/image005.png';
import image006 from '../assetes/images/survey/action-in-calculator-list/image006.png';
import image007 from '../assetes/images/survey/action-in-calculator-list/image007.png';
import image008 from '../assetes/images/survey/action-in-calculator-list/image008.png';
import image009 from '../assetes/images/survey/action-in-calculator-list/image009.png';
import image010 from '../assetes/images/survey/action-in-calculator-list/image010.png';
import image011 from '../assetes/images/survey/action-in-calculator-list/image011.png';
import image012 from '../assetes/images/survey/action-in-calculator-list/image012.png';
import image013 from '../assetes/images/survey/action-in-calculator-list/image013.png';
import image014 from '../assetes/images/survey/action-in-calculator-list/image014.png';
import image015 from '../assetes/images/survey/action-in-calculator-list/image015.png';
import image016 from '../assetes/images/survey/action-in-calculator-list/image016.png';
import image017 from '../assetes/images/survey/action-in-calculator-list/image017.png';
import image018 from '../assetes/images/survey/action-in-calculator-list/image018.png';
import image019 from '../assetes/images/survey/action-in-calculator-list/image019.png';
import image020 from '../assetes/images/survey/action-in-calculator-list/image020.png';
import image021 from '../assetes/images/survey/action-in-calculator-list/image021.png';
import image022 from '../assetes/images/survey/action-in-calculator-list/image022.png';
import image023 from '../assetes/images/survey/action-in-calculator-list/image023.png';
import image024 from '../assetes/images/survey/action-in-calculator-list/image024.png';
import image025 from '../assetes/images/survey/action-in-calculator-list/image025.png';
import image026 from '../assetes/images/survey/action-in-calculator-list/image026.png';
import image027 from '../assetes/images/survey/action-in-calculator-list/image027.png';

export default function CalculationLogic() {

useEffect(() => {
window.scrollTo(0, 0);
}, []);

return (
<>
    <div className='d-flex flex-column main-outer-wrapper'>
        <div className="flex-grow-1 d-flex survey-main-wrapper">
            <DocumentationSidebar />


            <div className="flex-grow-1 dashboard-page-outer">
                <div className='dashboard-page-wrap document-page-wrap'>
                    <Searchbar containerSelector=".search-scope" />
                    <div className='search-scope mt-4'>
                        <h1 className='mt-0 text-primary'>Calculation Logic</h1>
                        <p className='header-para'>
                            The Calculator module is designed to enable users to build and manage ROI (Return on
                            Investment) calculators that demonstrate the business value or potential savings a customer
                            can expect from using a specific product or solution.
                        </p>


                        <div className="card dashboard-card mb-4">
                            <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                                Calculations & Logics
                            </div>
                            <div className="card-body">
                                <img src={image002} alt="Calculations & Logics" className='img-fluid pt-10 pb-10' />

                                <p> Allows you to configure or modify the backend formulas, conditions, and logical
                                    flows of the ROI calculator.
                                    Useful for applying custom business rules and computation logic. Onclick on
                                    Calculations & Logics action , user redirected to this page. mainly divided into
                                    table list and create button which will explain in details as follows</p>


                                <p><b>Logic List Table</b></p>
                                <ul>
                                    <li><b>Logic Name - </b> The name of the logic rule (e.g., Show Results Page
                                        Supporting Wrappers). Below each name, the Added Date Time is displayed for
                                        tracking purposes.</li>
                                    <li><b>Created By - </b>The name of the user who created the logic rule </li>
                                    <li><b>Status - </b>Indicates whether the logic is currently Active or Inactive.
                                    </li>
                                    <li><b>Actions - </b>Indicates whether the logic is currently Active or Inactive.
                                        <ul>
                                            <li className='pt-10'><b>Edit -</b> On click, a pre-defined form will open
                                                for editing the selected logic.
                                                <img src={image003} alt="edit" className='pt-10 pb-10 img-fluid' />
                                            </li>
                                            <li><b>Delete -</b> On click, a confirmation popup will appear to delete the
                                                selected logic.
                                                <img src={image004} alt="delete" className='pt-10 pb-10' />
                                            </li>

                                        </ul>
                                    </li>
                                </ul>



                            </div>
                        </div>
                        <div className="card dashboard-card mb-4">
                            <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                                Create Button
                            </div>
                            <div className="card-body">


                                <p><b>Create Button - </b> When the Create button is clicked, the form which shown in
                                    edit action will opens up but in blank state. It allows the user to add the
                                    configuration of that specific logic rule.
                                    <img src={image005} alt="Create Button" className='img-fluid pt-10 pb-10' />
                                </p>
                                <ul>
                                    <li><b>Logic Name - </b>Text input to edit or update the name of the logic rule.
                                        <img src={image006} alt="Logic Name" className='img-fluid pt-10 pb-10' />
                                    </li>
                                    <li><b>When Section - </b>Defines the condition that must be met for the logic to
                                        trigger.
                                        <img src={image007} alt="When Section" className='img-fluid pt-10 pb-10' />
                                        <ul>
                                            <li><b>Condition Field</b> - Field where you choose the form input or
                                                variable you
                                                want to monitor or apply logic on. <br />
                                                <img src={image011} alt="Condition Field"
                                                    className='pt-10 pb-10' /><br />
                                                <b>Use Case: </b>
                                                You might want to show a specific message only if the user has
                                                entered a
                                                valid email or agreed to the terms. So, this field helps define
                                                "what to
                                                check".

                                            </li>
                                            <li> <b>Operator</b> - Describes the condition logic to compare the field's
                                                value with the given target value.<br />
                                                <img src={image012} alt="Operator" className='pt-10 pb-10' />
                                                <ul>
                                                    <li>Contains: Value includes specified text</li>
                                                    <li>Does not contain: Value excludes specified text</li>
                                                    <li>Does not start with: Value doesn’t begin with the text</li>
                                                    <li>Ends with: Value ends with specified text</li>
                                                    <li>Does not end with: Value doesn’t end with the text</li>
                                                    <li>Is: Exact match</li>
                                                    <li>Is not: Exact mismatch</li>
                                                    <li>Is empty: Field is blank</li>
                                                    <li>Is not empty: Field has any content</li>
                                                    <li><b>Use Case Examples - </b> <br />
                                                        <ul>
                                                            <li className="pt-10">1. Show a warning if email does not
                                                                contain @ </li>
                                                            <li>2. Enable Submit button only if checkbox is checked</li>
                                                            <li>3. Trigger a popup if field is empty when trying to
                                                                continue</li>
                                                        </ul>

                                                    </li>
                                                </ul>
                                            </li>
                                            <li><b> Value Type</b> - Specifies whether the comparison value is hardcoded
                                                or
                                                taken from another field/variable. <br />
                                                <img src={image013} alt="Value Type" className='pt-10 pb-10' />
                                                <ul>
                                                    <li>Static: Fixed value entered manually (e.g., "yes",
                                                        "admin@example.com")</li>
                                                    <li>Dynamic: Value fetched from another field or variable in
                                                        real-time</li>
                                                    <li><b>Use Case:</b>
                                                        <ul className='pt-10'>
                                                            <li> 1. If checking user input against a known string, use
                                                                Static</li>
                                                            <li> 2. If comparing input against another field value, use
                                                                Dynamic</li>
                                                        </ul>

                                                    </li>
                                                </ul>
                                            </li>
                                            <li><b>Value</b>  - Actual value that will be checked based on the above logic.
                                            </li>
                                            <li><b>Add</b>  - Adds this condition to the logic rule. Multiple conditions can be
                                                added if needed.
                                            </li>
                                        </ul>

                                    </li>
                                    <li><b>When Operator - </b>Used when you have multiple conditions, and you want to
                                        define how they are evaluated together (e.g., AND / OR).

                                        <img src={image008} alt="When Operator" className='pt-10 pb-10' />
                                        <ul>
                                            <li>AND: All conditions must be true.</li>
                                            <li>OR: At least one condition must be true.</li>
                                            <li><b> Use case:</b> Show a specific block only when the “Email” is filled
                                                and the user
                                                agreed to terms.
                                            </li>
                                        </ul>
                                    </li>
                                    <li><b>Then Section - </b>Defines the action(s) that will occur if the "When"
                                        condition(s) are satisfied.
                                        <img src={image009} alt="Then Section" className='pt-10 pb-10' />
                                        <ul>
                                            <li className='pt-10'><b>Action</b> - Select what action should be taken
                                                (e.g.,
                                                show/hide field, show error and calculate value). <br />
                                                <img src={image014} alt="Action" className='pt-10 pb-10' /> <br />
                                                <ul>
                                                    <li>Calculate: Perform computation.</li>
                                                    <li>Show/Hide Blocks: Toggle visibility of sections.</li>
                                                    <li>Show Error: Display validation errors.</li>
                                                </ul>
                                            </li>
                                            <li><b>Variable</b> - Choose the variable that the action applies to.<br />
                                                <img src={image015} alt="Variable" className='pt-10 pb-10' /> <br />
                                                <b>Use case: </b> Show an error if “Number of Employees” is empty.

                                            </li>
                                            <li>
                                                <b>Add/Remove</b> - Add or remove multiple actions under the same
                                                rule.<br />
                                                <img src={image016} alt="add and remove" className='pt-10 pb-10' />
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        <b>Save Button - </b> After editing the logic, click Save to apply the changes.
                                        <br />
                                        <img src={image010} alt="Save Button" className='pt-10 pb-10' />
                                    </li>


                                </ul>

                            </div>
                        </div>
                        <div className="card dashboard-card mb-4">
                            <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                                Example Use Cases
                            </div>
                            <div className="card-body">
                                <p><b> Example Use Case 1: Show Results Page Supporting Wrappers</b></p>
                                <ul>

                                    <img src={image026} alt="use case 1" className='img-fluid pt-10 pb-10' />
                                    <li>Logic Name: The rule is named "Show Results Page Supporting Wrappers," which
                                        indicates its purpose is to control the visibility of certain elements on a
                                        results page.</li>
                                    <li>When (The Condition): This section defines the trigger for the action. The
                                        condition is met when the "Advanced IT Support Option" field has a value that is
                                        equal to "2".</li>
                                    <li>Then (The Action): If the "When" condition is true, the system will perform the
                                        following actions:
                                        <ul>
                                            <li className="pt-10">Show a block or element named "Supporting
                                                recommendation...".</li>
                                            <li>Show another block or element named "Vodafone Business Services...".
                                            </li>
                                        </ul>
                                    </li>
                                    <li>In essence, this rule dictates that if a user selects or is assigned the
                                        "Advanced IT Support Option" with a value of 2, then two specific content blocks
                                        ("Supporting recommendation..." and "Vodafone Business Services...") will be
                                        made visible on the subsequent results page. This is a common feature in web
                                        development and content management systems to create personalized and dynamic
                                        user experiences.</li>
                                </ul>

                                <p> <b> Example Use Case 2: Calculate Licence value</b></p>
                                <ul>
                                    <img src={image027} alt="use case 2" className='img-fluid pt-10 pb-10' />
                                    <li>Logic Name: "Calculate Licence value of Basic - If Industry is
                                        Media/Advertising". This name clearly states the rule's purpose: to determine
                                        the value of a basic license specifically for customers in the Media/Advertising
                                        industry.</li>
                                    <li>When (The Condition): This section defines the trigger for the rule. The
                                        condition is met when the "Industry Radio Selection" field has a value that is
                                        equal to "3". In this system, the value '3' presumably corresponds to the
                                        "Media/Advertising" industry.</li>
                                    <li>Then (The Action): If the "When" condition is met, the system will perform the
                                        following action
                                        <ul>
                                            <li className="pt-10">It will "calculate" a value for the variable named
                                                "Basic Licence".</li>
                                            <li>The calculation method is to "assign" a "static" value of "0" to it.
                                            </li>
                                        </ul>
                                    </li>
                                    <li>In summary, this rule automatically sets the value of the "Basic Licence" to 0
                                        whenever a user selects the "Media/Advertising" industry (represented by the
                                        value 3). This is a common implementation for applying special offers,
                                        discounts, or waivers for specific customer segments. In this instance,
                                        customers from the Media/Advertising industry receive the basic license for
                                        free.</li>
                                </ul>

                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    </div>
</>
)
}